module.exports = "/_next/static/images/a9eb0bb7ba6f94fe202e9acdd441255d-mulher-com-cachos-maravilhosos-segurando-cartao-lg@2x.jpg";